import { useMeeting } from '../meeting/meetingProviderContextDef';
import { useEffect } from 'react';
import { eventEmitter, events } from '../utils';

/**
 *
 * @param {{
 *  onTranscriptionStateChanged?: Function,
 *  onTranscriptionText?: Function,
 * }} options
 * @returns {{
 *  startTranscription: ( data: Object ) => void
 *  stopTranscription: () => void
 * }}
 */
const useTranscription = ({
  onTranscriptionStateChanged = () => {},
  onTranscriptionText = () => {}
} = {}) => {
  const mMeeting = useMeeting();

  useEffect(() => {
    // on event listeners
    eventEmitter.on(
      events['transcription-state-changed'],
      onTranscriptionStateChanged
    );

    eventEmitter.on(events['transcription-text'], onTranscriptionText);

    // off event listeners
    return () => {
      eventEmitter.off(
        events['transcription-state-changed'],
        onTranscriptionStateChanged
      );
      eventEmitter.off(events['transcription-text'], onTranscriptionText);
    };
  }, []);

  /**
   * @param {{webhookUrl?:string, modelConfig?:any}} config?
   */
  const startTranscription = async config => {
    return await mMeeting.meeting.startTranscription(config);
  };

  const stopTranscription = async () => {
    return await mMeeting.meeting.stopTranscription();
  };

  return { startTranscription, stopTranscription };
};

export default useTranscription;
